import { render, staticRenderFns } from "./AddCompaniesModal.vue?vue&type=template&id=4f53abd3&scoped=true&"
import script from "./AddCompaniesModal.vue?vue&type=script&lang=js&"
export * from "./AddCompaniesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCompaniesModal.vue?vue&type=style&index=0&id=4f53abd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53abd3",
  null
  
)

export default component.exports